import Register from "pages/Auth/Register.js";
import Login from "pages/Auth/Login.js";
import Dashboard from "pages/Dashboard";
import Reports from "pages/Reports/Reports";
import ProductListing from "pages/ProductManagement/ProductListing";
import BrandMaster from "pages/Masters/BrandMaster";
import CustomerList from "pages/Customers/CustomerList";
import ProductCategory from "pages/Masters/ProductCategoryMaster";
import ManufacturerMaster from "pages/Masters/Manufacturer";
import JobTypeMaster from "pages/Masters/JobTypeMaster";
import UserDetails from "pages/UserManagement/UserDetails";
import CustomerDetails from "pages/Customers/CustomerDetails";
import TechnicianList from "pages/Technician/TechnicianList";
// import TechnicianListfor
import SpareParts from "pages/SpareParts/SpareParts";
import TechnicianDetails from "pages/Technician/TechnicianDetails";
import SparePartDetails from "pages/SpareParts/SparePartDetails";
import ProductDetails from "pages/ProductManagement/ProductDetails";
import LocationDetails from "pages/Customers/LocationDetails";
import JobsListing from "pages/Jobs/JobsListing";
import JobDetails from "pages/Jobs/JobDetails";
import PartsRequested from "pages/PartsRequested/PartsRequested";
import ServicesList from "pages/Services/ServicesList";
import PartsAvailability from "pages/PartsAvailability/PartsAvailability";
import JobScheduler from "pages/JobScheduler/JobScheduler";
import WarrantyApproval from "pages/Jobs/WarrantyApproval";
import { ROLES } from "components/Common/constants";
import UserListing from "pages/UserManagement/UserListing";
import { WORK_ORDER } from "components/Common/constants";
import AssignSubUserLocation from "pages/Customers/AssignSubUserLocation";
import OdooCustomersList from "pages/OdooPages/OdooCustomersList";
import OdooSpareParts from "pages/OdooPages/OdooSparePartsList";
import OdooServicesList from "pages/OdooPages/OdooServiceList";
import OdooManufacturer from "pages/OdooPages/OdooManufacturar";
import OdooQuotationsList from "pages/OdooPages/OdooQuotationList";
import ActionRequiredCustomerList from "pages/ActionRequiredPage/ActionRequiredPage";
import PaymentList from "pages/PaymentList/PaymentList";

const routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    rtlName: "لوحة القيادة",
    icon: "tim-icons icon-chart-pie-36",
    component: <Dashboard />,
    layout: "/admin",
    show: true,
    roles: [ROLES.ADMINISTRATOR],
  },
  {
    path: "/reports",
    name: "Reports",
    rtlName: "التقارير",
    icon: "tim-icons icon-chart-bar-32",
    component: <Reports />,
    layout: "/admin",
    show: true,
    roles: [ROLES.ADMINISTRATOR],
  },
  {
    path: "/job-scheduler",
    name: `${WORK_ORDER} Scheduler`,
    rtlName: "جدولة الوظيفة",
    icon: "tim-icons icon-calendar-60",
    component: <JobScheduler />,
    layout: "/admin",
    show: true,
    roles: [ROLES.ADMINISTRATOR],
  },
  {
    path: "/user",
    name: "Users",
    rtlName: "لوحة القيادة",
    icon: "tim-icons icon-single-02",
    component: <UserListing />,
    layout: "/admin",
    show: true,
    roles: [ROLES.ADMINISTRATOR],
  },

  {
    path: "/user/:id/details",
    name: "User Detail",
    rtlName: "لوحة القيادة",
    icon: "tim-icons icon-single-02",
    component: <UserDetails />,
    layout: "/admin",
    show: false,
    roles: [ROLES.ADMINISTRATOR],
  },

  {
    path: "/brand-master",
    name: "Brands",
    rtlName: "لوحة القيادة",
    icon: "tim-icons icon-single-02",
    component: <BrandMaster />,
    layout: "/admin",
    roles: [ROLES.ADMINISTRATOR],
  },
  {
    path: "/login",
    name: "Login",
    rtlName: "منتجات",
    icon: "tim-icons icon-bag-16",
    component: <Login />,
    layout: "/auth",
    show: false,
    roles: [ROLES.ADMINISTRATOR, ROLES.SPARE_PARTS],
  },
  {
    path: "/register",
    name: "Register",
    rtlName: "منتجات",
    icon: "tim-icons icon-bag-16",
    component: <Register />,
    layout: "/auth",
    show: false,
    roles: [ROLES.ADMINISTRATOR, ROLES.SPARE_PARTS],
  },
  {
    path: "/customers",
    name: "Customers",
    rtlName: "لوحة القيادة",
    icon: "fa fa-users text-left",
    component: <CustomerList />,
    layout: "/admin",
    show: true,
    roles: [ROLES.ADMINISTRATOR],
  },
  {
    path: "/customers/:id/details",
    name: "Customer Details",
    rtlName: "لوحة القيادة",
    icon: "fa fa-users",
    component: <CustomerDetails />,
    layout: "/admin",
    show: false,
    roles: [ROLES.ADMINISTRATOR],
  },
  {
    path: "/customers/:customerID/details/location-details/:locationID",
    name: "Location Details",
    rtlName: "لوحة القيادة",
    icon: "fa fa-users",
    component: <LocationDetails />,
    layout: "/admin",
    show: false,
    roles: [ROLES.ADMINISTRATOR],
  },
  {
    path: "/customers/:customerID/details/subUser-details/:subUserID",
    name: "Location Details",
    rtlName: "لوحة القيادة",
    icon: "fa fa-users",
    component: <AssignSubUserLocation />,
    layout: "/admin",
    show: false,
    roles: [ROLES.ADMINISTRATOR],
  },
  {
    path: "/technicians",
    name: "Technicians",
    rtlName: "لوحة القيادة",
    icon: "fa fa-users-gear text-left",
    component: <TechnicianList />,
    layout: "/admin",
    show: true,
    roles: [ROLES.ADMINISTRATOR],
  },
  {
    path: "/products",
    name: "Products",
    rtlName: "منتجات",
    icon: "tim-icons icon-bag-16",
    component: <ProductListing />,
    layout: "/admin",
    show: true,
    roles: [ROLES.ADMINISTRATOR],
  },
  {
    path: "/products/:id/details",
    name: "Product Details",
    rtlName: "لوحة القيادة",
    icon: "fa fa-users-gear",
    component: <ProductDetails />,
    layout: "/admin",
    show: false,
    roles: [ROLES.ADMINISTRATOR],
  },
  {
    path: "/spare-parts",
    name: "Spare Parts",
    rtlName: "قطع غيار",
    icon: "tim-icons icon-puzzle-10",
    component: <SpareParts />,
    layout: "/admin",
    show: true,
    roles: [ROLES.ADMINISTRATOR, ROLES.SPARE_PARTS],
  },
  {
    path: "/spare-parts/:id/details",
    name: "Spare Part Details",
    rtlName: "لوحة القيادة",
    icon: "fa fa-users-gear",
    component: <SparePartDetails />,
    layout: "/admin",
    show: false,
    roles: [ROLES.ADMINISTRATOR, ROLES.SPARE_PARTS],
  },
  {
    path: "/technicians/:id/details",
    name: "Technician Details",
    rtlName: "لوحة القيادة",
    icon: "fa fa-users-gear",
    component: <TechnicianDetails />,
    layout: "/admin",
    show: false,
    roles: [ROLES.ADMINISTRATOR],
  },
  {
    path: "/warranty-approval",
    name: "Warranty Requests",
    rtlName: "لوحة القيادة",
    icon: "fa fa-list-check text-left",
    component: <WarrantyApproval />,
    layout: "/admin",
    show: false,
    roles: [ROLES.ADMINISTRATOR],
  },
  {
    path: "/services",
    name: "Services",
    rtlName: "لوحة القيادة",
    icon: "tim-icons icon-settings",
    component: <ServicesList />,
    layout: "/admin",
    show: true,
    roles: [ROLES.ADMINISTRATOR],
  },
  {
    path: "/jobs",
    name: `${WORK_ORDER}s`,
    rtlName: "لوحة القيادة",
    icon: "tim-icons icon-bullet-list-67",
    component: <JobsListing />,
    layout: "/admin",
    show: true,
    roles: [ROLES.ADMINISTRATOR],
  },
  {
    path: "/jobs/:id/details",
    name: `${WORK_ORDER}s`,
    rtlName: "لوحة القيادة",
    icon: "tim-icons icon-bullet-list-67",
    component: <JobDetails />,
    layout: "/admin",
    show: false,
    roles: [ROLES.ADMINISTRATOR],
  },
  {
    path: "/parts-requested",
    name: "Parts Requested",
    rtlName: "لوحة القيادة",
    icon: "tim-icons icon-delivery-fast",
    component: <PartsRequested />,
    layout: "/admin",
    show: true,
    roles: [ROLES.ADMINISTRATOR, ROLES.SPARE_PARTS],
  },
  {
    path: "/parts-availability",
    name: "Parts Availability",
    rtlName: "توافر الأجزاء",
    icon: "fa-solid fa-warehouse text-left",
    component: <PartsAvailability />,
    layout: "/admin",
    show: false,
    roles: [ROLES.ADMINISTRATOR, ROLES.SPARE_PARTS],
  },
  {
    path: "/odoo-customers",
    name: "Odoo Customers",
    rtlName: "توافر الأجزاء",
    icon: "fa-solid fa-warehouse text-left",
    component: <OdooCustomersList />,
    layout: "/admin",
    show: false,
    roles: [ROLES.ADMINISTRATOR],
  },
  {
    path: "/odoo-spareParts",
    name: "Odoo Spare Parts",
    rtlName: "توافر الأجزاء",
    icon: "fa-solid fa-warehouse text-left",
    component: <OdooSpareParts />,
    layout: "/admin",
    show: false,
    roles: [ROLES.ADMINISTRATOR],
  },
  {
    path: "/odoo-service",
    name: "Odoo Service",
    rtlName: "توافر الأجزاء",
    icon: "fa-solid fa-warehouse text-left",
    component: <OdooServicesList />,
    layout: "/admin",
    show: false,
    roles: [ROLES.ADMINISTRATOR],
  },
  {
    path: "/odoo-manufacturer",
    name: "Odoo Manufacturer",
    rtlName: "توافر الأجزاء",
    icon: "fa-solid fa-warehouse text-left",
    component: <OdooManufacturer />,
    layout: "/admin",
    show: false,
    roles: [ROLES.ADMINISTRATOR],
  },
  {
    path: "/odoo-quotation",
    name: "Odoo Quotation",
    rtlName: "توافر الأجزاء",
    icon: "fa-solid fa-warehouse text-left",
    component: <OdooQuotationsList />,
    layout: "/admin",
    show: false,
    roles: [ROLES.ADMINISTRATOR],
  },
  {
    path: "/action-required",
    name: "Action Required Quotation",
    rtlName: "توافر الأجزاء",
    icon: "fa-solid fa-warehouse text-left",
    component: <ActionRequiredCustomerList />,
    layout: "/admin",
    show: false,
    roles: [ROLES.ADMINISTRATOR],
  },
  {
    path: "/payments",
    name: "Payment List",
    rtlName: "توافر الأجزاء",
    icon: "fa-solid fa-warehouse text-left",
    component: <PaymentList />,
    layout: "/admin",
    show: false,
    roles: [ROLES.ADMINISTRATOR],
  },
  {
    show: true,
    collapse: true,
    name: "Masters",
    rtlName: "المكونات",
    icon: "tim-icons icon-molecule-40",
    state: "componentsCollapse",
    roles: [ROLES.ADMINISTRATOR],
    views: [
      {
        show: false,
        path: "/brand-master",
        name: "Brands",
        rtlName: "وصفت",
        miniName: "B",
        rtlMini: "ب",
        component: <BrandMaster />,
        layout: "/admin",
        roles: [ROLES.ADMINISTRATOR],
      },
      {
        show: true,
        path: "/product-category",
        name: "Product Categories",
        rtlName: "وصفت",
        miniName: "PC",
        rtlMini: "ب",
        component: <ProductCategory />,
        layout: "/admin",
        roles: [ROLES.ADMINISTRATOR],
      },
      {
        show: true,
        path: "/manufacturer-master",
        name: "Manufacturers",
        rtlName: "وصفت",
        miniName: "M",
        rtlMini: "ب",
        component: <ManufacturerMaster />,
        layout: "/admin",
        roles: [ROLES.ADMINISTRATOR],
      },
      {
        show: true,
        path: "/job-type-master",
        name: `${WORK_ORDER} Types`,
        rtlName: "وصفت",
        miniName: "JT",
        rtlMini: "ب",
        component: <JobTypeMaster />,
        layout: "/admin",
        roles: [ROLES.ADMINISTRATOR],
      },
    ],
  },
];

export default routes;
